module.exports = __webpack_public_path__ + "static/media/Obedience01.b33bb707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Obedience01.jpg
// module id = 345
// module chunks = 0